import React, { useState } from 'react';
import styles from './styles.module.scss'; // Or use Tailwind classes
import H3 from '../../../components/typography/h3';

const faqs = [
  {
    question: 'How do you customize software to fit our business needs?',
    answer: 'We assess your requirements and tailor the software accordingly using scalable and modular design patterns.',
  },
  {
    question: 'How long does it take to complete a software project?',
    answer: 'The timeline depends on project complexity but typically ranges from 4 to 12 weeks.',
  },
  {
    question: 'Do you provide ongoing support and maintenance after delivery?',
    answer: 'Yes, we offer multiple support tiers to ensure your system remains updated and secure.',
  },
  {
    question: 'How long does it take to see results from SEO efforts?',
    answer: 'SEO results generally start appearing within 3 to 6 months, depending on your industry and competition.',
  },
];

const FaqSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={styles.faqContainer}>
      
      <div className={styles.left}>
             <H3>
      <h2 className={styles.heading}>
Frequently Asked Questions
and Helpful Answers
      </h2>
      </H3>
</div>
      <div className={styles.right}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}
          >
            <div className={styles.question} onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
           <span className={styles.icon}>
  {activeIndex === index ? (
    '−'
  ) : (
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.6875 12.75H11.25V16.3125C11.25 16.4156 11.3344 16.5 11.4375 16.5H12.5625C12.6656 16.5 12.75 16.4156 12.75 16.3125V12.75H16.3125C16.4156 12.75 16.5 12.6656 16.5 12.5625V11.4375C16.5 11.3344 16.4156 11.25 16.3125 11.25H12.75V7.6875C12.75 7.58437 12.6656 7.5 12.5625 7.5H11.4375C11.3344 7.5 11.25 7.58437 11.25 7.6875V11.25H7.6875C7.58437 11.25 7.5 11.3344 7.5 11.4375V12.5625C7.5 12.6656 7.58437 12.75 7.6875 12.75Z" fill="#444444"/>
<path d="M20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM19.6875 19.6875H4.3125V4.3125H19.6875V19.6875Z" fill="#444444"/>
</svg>

  )}
</span>
            </div>
            {activeIndex === index && <div className={styles.answer}>{faq.answer}</div>}
          </div>
        ))}
      </div>
    </div>
    
  );
};

export default FaqSection;
